import React, { Component } from 'react';
import PropTypes from 'prop-types';
import MetaDataWrapper from 'modules/Common/containers/MetaDataWrapper';
import { toSlug } from 'utils';

import { canonicalRel, metaDescription } from 'utils/seoUtils';
import { layoutAsyncConnect } from 'utils/asyncConnectWrapper';
import catchLifeCycleErrors from 'utils/catchLifeCycleErrors';

import { getByCompetition, loadByCompetition, isLoadingByCompetition } from '../reducers/leagueTable';
import { load, isLoading } from '../reducers/competitions';

import Dropdown from 'modules/Common/components/Dropdown';
import Table from 'modules/Common/components/Table';

require('./FootballLeagues.scss');

function href({name, competition_reference: {id}}) {
  return `/football/league-tables/${toSlug(name)}/${id}`;
}

@layoutAsyncConnect(
  'FootballLeagues',
  [
    {
      dispatch: () => load(),
      preventResolve: ({state}) => isLoading(state),
      state: state => ({ competitionList: state.football.competitions.list })
    },
    {
      dispatch: ({params: {competition}}) => loadByCompetition(competition),
      preventResolve: ({state, params: {competition}}) => isLoadingByCompetition(state, competition),
      state: (state, {params: {competition}}) => ({ leagueTables: getByCompetition(state, competition) })
    }
  ]
)
@catchLifeCycleErrors
export default class FootballLeaguesContainer extends Component {
  static propTypes = {
    competitionList: PropTypes.array,
    leagueTables: PropTypes.array,
    params: PropTypes.object
  };

  createLeagueTables(tables) {
    return tables.map((table, key) => {
      return (
        <section key={key} className="football-leagues-section">
        { table.label &&
          <header>
            <h2>{table.label}</h2>
          </header>
        }
          <Table row={table.row}/>
        </section>
      )
    })
  }

  getKeyAndDescription(tables) {
    if (tables.length > 0) {
      for(let i = 0; i < tables.length; i++) {
        if (tables[i].table_description) {
          return (
            <div className="football-leagues-key">
              <h2>Key</h2>
              { tables[i].table_description.split("\n").map((p, i) => <p key={i}>{p}</p>) }
            </div>
          )
        }
      }
    }
    return null
  }

  render() {
    const {
      competitionList,
      leagueTables,
      params: {
        competition
      }
    } = this.props;

    if (!competitionList) {
      return (
        <div className="default-no-article">
          <p>Competition tables currently unavailable. Please check back later.</p>
        </div>
      );      
    }

    const listToShow = competitionList.filter(c => c.show_tables).sort((a, b) => (a.sort_order - b.sort_order));

    const selectedCompetition = competition ? listToShow.filter(c => c.competition_reference.id == competition)[0] : listToShow[0];

    const dropdownOptions = listToShow.map(c => ({
      href: href(c),
      text: c.name
    }));

    dropdownOptions[0].alternatives = [{
      href: "/football/league-tables",
      isIndex: true
    }];

    const helmetProps = {
      title: `${selectedCompetition.name} League Table`,
      ...canonicalRel(href(selectedCompetition)),
      ...metaDescription(`Latest table for ${selectedCompetition.name}`)
    };

    let hasLeague = false;
    if (leagueTables.length > 0) {
      hasLeague = !!leagueTables[0].row.filter(r => !r.header).length;
    }

    return (
      <div className="football-leagues-content">
          <MetaDataWrapper helmetProps={helmetProps}/>
          <Dropdown title="COMPETITIONS" options={dropdownOptions} shouldNavigate={true}/>
          <h1>{selectedCompetition.name}</h1>
        {
          hasLeague
            ? this.createLeagueTables(leagueTables)
            : <div className="football-leagues-key"><p>There is no league data available for {selectedCompetition.name} at the moment.</p></div>
        }
        { this.getKeyAndDescription(leagueTables) }
      </div>
    );
  }
}



// WEBPACK FOOTER //
// ./modules/Football/containers/FootballLeaguesContainer.js